import React from "react";
import styled from "styled-components";
import { TRIAL_DAYS } from "utils/constants";

import { SubscribeBtn } from 'components/buttons';

import Header from "./Header";
import WhyJP from "./WhyJP";
import SupportedBy from "./SupportedBy";
import MeetJP from "components/Home/MeetJP";
import FeaturedCouses from "components/Home/FeaturedCourses";
import PuddinPops from "./PuddinPops";
import Proof from "./Proof";

import FinalWords from "components/Home/FinalWords";
import Footer from "components/_core/Footer";
import CourseModal from "components/Courses/CourseModal";
import Seo from "components/Seo";
import { useSelector } from "react-redux";

const CTA = styled(SubscribeBtn)`
    text-transform: none;

    padding: 13px 30px;
    width: 100%;

    max-width: 350px;
    
    border: 2px solid #fff;
    box-shadow: 0px 6px 0 0 #00000021;

    margin: 30px 0;
    font-size: 20px;

    div {
        font-style: italic;
        font-size: 15px;
    }
`;

const SatisfactionGuarantee = styled.p`
    font-weight: 500;
    color: #666;
    font-size: 14px;
    margin-top: -20px;
`;

const CTAButton = ({ whiteText }) => {
    const isSubscriber = useSelector(state => state.user.userData.isSubscriber);
    
    if (isSubscriber) {
        // just add some space if the user is already a subscriber
        return <div style={{ height: '30px' }}></div>;
    }

    return (
        <>
            <CTA pill large>
                Start Improvising Now!
                {TRIAL_DAYS > 0 ? <div>Try 7 Days Free</div> : <div>Sign Up Now</div>}
            </CTA>
            <SatisfactionGuarantee style={whiteText ? { color: '#fff' }: {}}>100% Satisfaction Guarantee</SatisfactionGuarantee>
        </>
    );
};

// headings are stored as HTML in the CMS, but titles and meta descriptions need plain text
const stripTags = html => (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

const LandingPage = ({
    heading,
    subHeading,
    testimonial,
    testimonialByline,
    videoId,
    useEmailForm
}) => {

    return (
        <div style={{ overflow: 'hidden'}}>
            <Seo
                title={stripTags(heading)}
                description={stripTags(subHeading) || undefined} />
            <Header
                title={heading}
                subtitle={subHeading}
                testimonial={testimonial}
                testimonialAuthor={testimonialByline}
                videoId={videoId}
                Button={CTAButton}
                useEmailForm={useEmailForm}
           />

           <WhyJP Button={CTAButton} overlap={true} />
           <Proof Button={CTAButton} />
           <SupportedBy />
           <PuddinPops Button={CTAButton} />
           <MeetJP Button={CTAButton} />
           <FeaturedCouses />
           <FinalWords Button={CTAButton} />
           <Footer />
           <CourseModal />
        </div>
    );
};

export default LandingPage;
